export const REVERB = 'REVERB';
export const DELAY = 'DELAY';
export const PHASER = 'PHASER';
